import { __assign, __spreadArray } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
    class: "post-dragable-component",
    style: { "--draggable-component-gap": "0.5rem" }
};
var _hoisted_2 = { class: "new-draft-create-form" };
var _hoisted_3 = { class: "new-draft-form-item" };
var _hoisted_4 = { class: "new-draft-form-item-content" };
var _hoisted_5 = { class: "new-draft-form-item" };
var _hoisted_6 = { class: "new-draft-form-item-content" };
var _hoisted_7 = { class: "new-draft-form-item" };
var _hoisted_8 = { class: "new-draft-form-item-content" };
var _hoisted_9 = { class: "new-draft-form-item" };
var _hoisted_10 = { class: "new-draft-form-item-content" };
var _hoisted_11 = { class: "new-draft-modal-footer" };
import { onBeforeUnmount, onMounted, ref } from "vue";
import { Motion, AnimatePresence } from "motion-v";
import PostDraftItemBox from "@/components/custom/PostDraftItemBox.vue";
import CategorySelector from "@/components/MdEditAbout/CategorySelector.vue";
import TagSelector from "@/components/MdEditAbout/TagSelector.vue";
import CoverUploader from "@/components/MdEditAbout/CoverUploader.vue";
import NullView from "@/views/tipViews/Null.vue";
import api from "@/utils/api";
import tools from "@/utils/tools";
var scrollThreshold = 150;
export default /*@__PURE__*/ _defineComponent({
    __name: 'postDraftManager',
    setup: function (__props) {
        var PostDraftContainer = ref(null);
        var isShowToTop = ref(false);
        var contentRef = window.menuContentContainerRef;
        /**
         * Represents a draft item for a post.
         * @property {string} title - The title of the draft.
         * @property {string} draftID - The unique identifier for the draft.
         * @property {string} lastUpdateTime - The last time the draft was updated.
         * @property {string|null} category - The category of the draft, can be null.
         * @property {string|null} cover - The cover image of the draft, can be null.
         */
        var draftItemLists = ref([]);
        api.request.get("/draftlist").then(function (res) {
            var resp = res;
            if (resp.code !== 0) {
                window.$msgError("获取草稿列表失败: " + resp.msg);
                return;
            }
            else {
                draftItemLists.value = res.data;
            }
        });
        var newDraftInfo = ref({
            title: "",
            category: null,
            tags: [],
            cover: undefined,
        });
        // setInterval(() => {
        //   console.log("newDraftInfo:", newDraftInfo.value);
        // }, 2000);
        var newDraftPopupVisible = ref(false);
        var createNewDraft = function () {
            console.log("Create new draft");
            newDraftInfo.value = {
                title: "",
                category: null,
                tags: [],
                cover: undefined,
            };
            newDraftPopupVisible.value = true;
        };
        var sendCreateNewDraft = function () {
            if (newDraftInfo.value.title === "" ||
                newDraftInfo.value.category === null ||
                newDraftInfo.value.category === "") {
                window.$notifyError("信息缺失", "草稿标题为必填项");
                console.log("草稿标题为必填项");
                return;
            }
            console.log("send new draft info", newDraftInfo.value.tags);
            api.request
                .quickPost("/createdraft", {
                title: newDraftInfo.value.title,
                category: newDraftInfo.value.category,
                tags: newDraftInfo.value.tags,
                cover: newDraftInfo.value.cover,
            })
                .then(function (res) {
                var resp = res;
                if (resp.code !== 0) {
                    window.$msgError("创建草稿失败: " + resp.msg);
                    return;
                }
                else {
                    newDraftPopupVisible.value = false;
                    tools.jumptoLocal("/edit/post-edit?uuid=".concat(resp.data.draftID));
                }
            });
        };
        var draftContainerToTop = function () {
            if (contentRef.value) {
                contentRef.value.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
                console.log("Draft container to top");
            }
            else {
                console.log("Draft container is null");
            }
        };
        var renderDraftItemDelete = function (draftID) {
            for (var i = 0; i < draftItemLists.value.length; i++) {
                if (draftItemLists.value[i].draftID === draftID) {
                    draftItemLists.value.splice(i, 1);
                    return;
                }
            }
            window.$notifyError("删除草稿渲染失败", "草稿不存在");
        };
        var renderDraftToTop = function (draftID) {
            for (var i = 0; i < draftItemLists.value.length; i++) {
                if (draftItemLists.value[i].draftID === draftID) {
                    draftItemLists.value = __spreadArray(__spreadArray([
                        draftItemLists.value[i]
                    ], draftItemLists.value.slice(0, i), true), draftItemLists.value.slice(i + 1), true);
                    return;
                }
            }
            window.$notifyError("置顶草稿渲染失败", "草稿不存在");
        };
        var onContentContainerScroll = null;
        onMounted(function () {
            if (contentRef.value) {
                var contentElement_1 = contentRef.value;
                onContentContainerScroll = function () {
                    if (contentElement_1.scrollTop > scrollThreshold) {
                        isShowToTop.value = true;
                    }
                    else {
                        isShowToTop.value = false;
                    }
                };
                contentElement_1.addEventListener("scroll", onContentContainerScroll);
            }
            else {
                console.error("PostDraftContainer is null");
            }
        });
        onBeforeUnmount(function () {
            if (contentRef.value && onContentContainerScroll) {
                var contentElement = contentRef.value;
                contentElement.removeEventListener("scroll", onContentContainerScroll);
            }
        });
        return function (_ctx, _cache) {
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_input = _resolveComponent("n-input");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_card = _resolveComponent("n-card");
            var _component_n_modal = _resolveComponent("n-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "post-draft-all-container",
                    ref_key: "PostDraftContainer",
                    ref: PostDraftContainer
                }, [
                    (draftItemLists.value.length !== 0)
                        ? (_openBlock(), _createBlock(_unref(AnimatePresence), {
                            key: 0,
                            class: "post-draft-container",
                            mode: "popLayout",
                            multiple: "",
                            as: "div"
                        }, {
                            default: _withCtx(function () { return [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftItemLists.value, function (item, index) {
                                    return (_openBlock(), _createBlock(_unref(Motion), {
                                        style: { "width": "100%", "position": "relative" },
                                        key: item.draftID,
                                        "data-key": item.draftID,
                                        animate: { scale: 1, opacity: 1 },
                                        exit: {
                                            scale: 0.8,
                                            opacity: 0,
                                            transition: {
                                                duration: 0.5,
                                            },
                                        },
                                        transition: {
                                            type: 'spring',
                                        },
                                        layout: true
                                    }, {
                                        default: _withCtx(function () { return [
                                            (_openBlock(), _createBlock(PostDraftItemBox, _mergeProps({ ref_for: true }, __assign(__assign({}, item), { onDelete: renderDraftItemDelete, onToTop: renderDraftToTop }), {
                                                key: item.draftID
                                            }), null, 16))
                                        ]; }),
                                        _: 2
                                    }, 1032, ["data-key"]));
                                }), 128))
                            ]; }),
                            _: 1
                        }))
                        : (_openBlock(), _createBlock(NullView, { key: 1 })),
                    _createVNode(_unref(Motion), {
                        drag: true,
                        "drag-constraints": PostDraftContainer.value || undefined,
                        class: "draft-motion-draggable"
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_Transition, { name: "draft-to-top-sbtn-show" }, {
                                    default: _withCtx(function () { return [
                                        (isShowToTop.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "post-draft-fix-btn",
                                                onClick: draftContainerToTop
                                            }, " 回到顶部 "))
                                            : _createCommentVNode("", true)
                                    ]; }),
                                    _: 1
                                }),
                                _createElementVNode("div", {
                                    class: "post-draft-fix-btn",
                                    onClick: createNewDraft
                                }, "新建草稿")
                            ])
                        ]; }),
                        _: 1
                    }, 8, ["drag-constraints"])
                ], 512),
                _createVNode(_component_n_modal, {
                    show: newDraftPopupVisible.value,
                    "onUpdate:show": _cache[6] || (_cache[6] = function ($event) { return ((newDraftPopupVisible).value = $event); }),
                    draggable: "",
                    closable: "",
                    class: "usn"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_card, {
                            style: { "width": "600px" },
                            title: "新建文章草稿",
                            bordered: false,
                            size: "huge",
                            role: "dialog",
                            "aria-modal": "true"
                        }, {
                            "header-extra": _withCtx(function () { return [
                                _createVNode(_component_n_icon, {
                                    size: "1.6rem",
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (newDraftPopupVisible.value = false); })
                                }, {
                                    default: _withCtx(function () { return _cache[7] || (_cache[7] = [
                                        _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                    ]); }),
                                    _: 1
                                })
                            ]; }),
                            footer: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_n_button, {
                                        onClick: _cache[5] || (_cache[5] = function ($event) { return (newDraftPopupVisible.value = false); })
                                    }, {
                                        default: _withCtx(function () { return _cache[12] || (_cache[12] = [
                                            _createTextVNode("取消")
                                        ]); }),
                                        _: 1
                                    }),
                                    _createVNode(_component_n_button, {
                                        type: "primary",
                                        onClick: sendCreateNewDraft
                                    }, {
                                        default: _withCtx(function () { return _cache[13] || (_cache[13] = [
                                            _createTextVNode("创建")
                                        ]); }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "new-draft-form-ite-title" }, " 文章标题 ", -1)),
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(_component_n_input, {
                                                placeholder: "输入文章标题",
                                                value: newDraftInfo.value.title,
                                                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) { return ((newDraftInfo.value.title) = $event); })
                                            }, null, 8, ["value"])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_5, [
                                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "new-draft-form-ite-title" }, " 选择分类 ", -1)),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createVNode(CategorySelector, {
                                                "bind-value": newDraftInfo.value.category,
                                                "onUpdate:bindValue": _cache[2] || (_cache[2] = function ($event) { return ((newDraftInfo.value.category) = $event); })
                                            }, null, 8, ["bind-value"])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "new-draft-form-ite-title" }, " 选择标签 ", -1)),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(TagSelector, {
                                                "bind-value": newDraftInfo.value.tags,
                                                "onUpdate:bindValue": _cache[3] || (_cache[3] = function ($event) { return ((newDraftInfo.value.tags) = $event); })
                                            }, null, 8, ["bind-value"])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "new-draft-form-ite-title" }, " 上传封面 ", -1)),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(CoverUploader, {
                                                modelValue: newDraftInfo.value.cover,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((newDraftInfo.value.cover) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ])
                                ])
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ], 64));
        };
    }
});
